import React, { useEffect, useRef, useState } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { useLocation } from 'react-router-dom'
import Select, { CSSObjectWithLabel } from 'react-select'
import { fetchData, formatNumber, toasterrormsg, BOOKABLE_CATEGORIES } from '../../../reusable'
import { getCSS, getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
import { Tr } from '../../../_metronic/i18n/Tr'

type Props = {
  className: string
  data: { name: string; data: { x: string; y: number; commission: number; booking: number; avgCost: number }[] }[]
  categories: string[]
  totalRevenue: string
  sendData?: any
  sendData2?: any
  length?: any
}

const ChartsWidget9v3: React.FC<Props> = ({
  className,
  data,
  categories,
  totalRevenue,
  sendData,
  sendData2,
  length,
}) => {
  let t = Tr()

  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const location = useLocation()
  const [selectedCategory, setSelectedCategory] = useState('') as any
  const [selectedVendor, setSelectedVendor] = useState('') as any
  const [vendorList, setVendorList] = useState([])
  const [categoryList] = useState(BOOKABLE_CATEGORIES) as any


  const currentYear = new Date().getFullYear()
  const yearList = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const [monthList] = useState([
    { value: '', label: 'All' },
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any

  const [selectedYear, setSelectedYear] = useState(yearList[0]) as any
  const [selectedMonth, setSelectedMonth] = useState(monthList[0]) as any



  const getvendorlist = async (category: any) => {
    let param: any = {
      categoryId: category,
    }
    const response: any = await fetchData('admin/vendorList', param)

    if (response.status == '200') {
      const data = response.data.map((item: any) => {
        return { value: item.vendorId, label: item.fullName }
      })
      setVendorList(data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data, categories])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data, categories , t))
    if (chart) {
      chart.render()
    }

    return chart
  }


  var currentLocation = location.pathname
  return (
    <>

      {location.pathname === '/viewcategorywiseearningbyyearmonth' ? (
        <div className='d-flex flex-wrap justify-content-center gap-4 mb-5'>
          <Select
            name='selectYear'
            id='selectYear'
            placeholder={t('Select Year')}
            isSearchable={true}
            options={yearList}
            value={yearList.find((option: any) => option.value === selectedYear?.value) || null}
            onChange={(e: any) => {
              setSelectedYear(e)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
            }}
          />

          <Select
            name='selectMonth'
            id='selectMonth'
            placeholder={t('Select Month')}
            isSearchable={true}
            options={monthList}
            value={
              monthList.find((option: any) => option.value === selectedMonth?.value) || null
            }
            onChange={(e: any) => setSelectedMonth(e)}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
            }}
          />

          <button
            className='btn btn-success'
            onClick={() =>
              sendData2
                ? sendData2({
                  year: selectedYear.value,
                  monthId: selectedMonth.value,
                })
                : ''
            }
          >
            {t("Apply")}
          </button>

          <button
            className='btn btn-danger'
            onClick={() => {
              setSelectedYear('')
              setSelectedMonth('')
              sendData2 &&
                sendData2({
                  year: '',
                  monthId: '',
                })
            }}
          >
            {t("Clear")}
          </button>
        </div>
      ) : (
        ''
      )}
      <div className={`card ${className} position-relative`}>
        <img
          src={toAbsoluteUrl('/media/otherSVG/Group148.svg')}
          className='position-absolute top-0 end-0'
          style={{ zIndex: 0 }}
        />

        <div className='card-header border-0 pt-5' style={{ zIndex: 1 }}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1 d-flex align-items-center'>
              <FontAwesomeIcon icon={faCircleCheck} className='fontsize35px me-3 themeGreenColor' />
              <span className='fs-3 fw-bold'>{t("Total Revenue")}</span>
            </span>
          </h3>

          {location.pathname === '/viewvendorwiseearning/' ? (
            <div className='d-flex flex-wrap gap-4'>
              <Select
                name='selectCategory'
                id='selectCategory'
                placeholder={t('Select Category')}
                isSearchable={true}
                options={categoryList}
                value={
                  categoryList.find((option: any) => option.value === selectedCategory) || null
                }
                onChange={(e: any) => {
                  setSelectedCategory(e.value)
                  getvendorlist(e.value)
                }}
              />

              <Select
                name='selectVendor'
                id='selectVendor'
                placeholder={t('Select Vendor')}
                isSearchable={true}
                options={vendorList}
                value={
                  vendorList.find((option: any) => option.value === selectedVendor?.value) || null
                }
                onChange={(e: any) => setSelectedVendor(e)}
              />

              <button
                className='btn btn-success'
                onClick={() =>
                  sendData
                    ? sendData({
                      vendorName: selectedVendor.label,
                      vendorId: selectedVendor.value,
                      categoryId: selectedCategory,
                    })
                    : ''
                }
              >
                {t("Apply")}
              </button>

              <button
                className='btn btn-danger'
                onClick={() => {
                  setSelectedCategory('')
                  setSelectedVendor('')
                  setVendorList([])
                  sendData &&
                    sendData({
                      vendorName: '',
                      vendorId: '',
                      categoryId: '',
                    })
                }}
              >
                {t("Clear")}
              </button>
            </div>
          ) : (
            ''
          )}



          <label className='fontsize48px fontweight700 w-100 themeBlueColor'>
            {length == '0' ? '0' : formatNumber(parseFloat(totalRevenue))}
          </label>
        </div>

        {length != '0' ? (
          <div className='card-body '>
            <div
              ref={chartRef}
              id='kt_charts_widget_1_chart'
              className='mt-10'
              style={{ height: '350px' }}
            />
          </div>
        ) : (
          <div className='d-flex justify-content-center align-items-center'>
            <h1 className='mt-10'>
              {' '}
              {currentLocation == "/dashboard" ? "" : currentLocation == '/viewcategorywiseearningbyyearmonth'
                ? selectedYear == '' && selectedMonth == ''
                  ? 'No Data Available'
                  : 'There Is No Data In the Selected Year and Month'
                : selectedVendor.label != '' &&
                  selectedVendor.label != undefined &&
                  selectedVendor.label != null
                  ? selectedVendor.label + ' No Data Available'
                  : 'This vendor has no data'}{' '}
            </h1>
          </div>
        )}
      </div>
    </>
  )
}

export { ChartsWidget9v3 }

function getChartOptions(
  height: number,
  data: { name: string; data: { x: string, y: number, commission: number, booking: number, avgCost: number }[] }[],
  categories: string[],
    t: (key: string) => string // 👈 add this

): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500');
  const borderColor = getCSSVariableValue('--bs-gray-200');
  const baseColor = getCSSVariableValue('--greencolorprofit');

  return {
    series: data,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (val: any, { series, seriesIndex, dataPointIndex, w }) {
          const commission = w.config.series[seriesIndex].data[dataPointIndex].commission;
          const booking = w.config.series[seriesIndex].data[dataPointIndex].booking;
          const avgCost = w.config.series[seriesIndex].data[dataPointIndex].avgCost;

          return `
            <span >${t("Total Revenue")}:</span> 
            <span style="color: black; font-weight: bold;">${formatNumber(parseFloat(val))}</span><br>
            <span >${t("Insayr Revenue")}:</span> 
            <span style="color: black; font-weight: bold;">${formatNumber(parseFloat(commission))}</span><br>
            <span >${t("Total Booking")}:</span> 
            <span style="color: black; font-weight: bold;">${parseFloat(booking)}</span><br>
            <span >${t("Avg. Cost Per Booking")}:</span> 
            <span style="color: black; font-weight: bold;">${formatNumber(parseFloat(avgCost))}</span>
          `;
        }
      }
    },
    colors: [baseColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };
}